import { FC } from 'react';
import classNames from 'classnames';
import { Icon } from '@lambdacurry/component-library';

import { Footer, FooterContent, FooterDiamond, FooterProps } from '../../Footer';

export interface GettingStartedFooterProps extends FooterProps {}

export const GettingStartedHealthyQuickEasyFooter: FC<GettingStartedFooterProps> = ({ className, ...props }) => (
  <Footer className={classNames('getting-started__footer mt-20 flex-grow-0', className)} {...props}>
    <FooterContent>
      <div className="text-center xs:flex items-center mx-6 md:mx-10 gap-4">
        <Icon className="!w-8 !h-8" viewBox="0 0 34 34" name="sprout" />
        <p className="text-sm md:text-base">Healthy</p>
      </div>
      <FooterDiamond />
      <div className="text-center xs:flex items-center mx-6 md:mx-10 gap-4">
        <Icon className="!w-8 !h-8" viewBox="0 0 34 34" name="stopWatch" />
        <p className="text-sm md:text-base">Quick</p>
      </div>
      <FooterDiamond />
      <div className="text-center xs:flex items-center mx-6 md:mx-10 gap-4">
        <Icon className="!w-8 !h-8" viewBox="0 0 34 34" name="snap" />
        <p className="text-sm md:text-base">Easy</p>
      </div>
    </FooterContent>
  </Footer>
);
